import React from 'react'

const Loader = () => {
  return (
    <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "300px"}}>
        <span class="loader" style={{height: "36px", width: "36px"}}></span>
    </div>
  )
}

export default Loader